import { Company } from 'api/models';
import { Task } from 'api/tasks';
import { View } from 'api/views/types';
import { TasksViewDefinition } from 'components/organisms/tasks/views';

export enum TasksToBeShown {
  AllTasks = 'ALL_TASKS',
  AllSharedViewsInProject = 'ALL_SHARED_VIEWS_IN_PROJECT',
  OnlySpotlitSharedViews = 'ONLY_SPOTLIT_SHARED_VIEWS',
  CustomFilter = 'CUSTOM_FILTER',
}

export interface ProjectTasksListData extends Record<string, unknown> {
  title: string;
  description: string;
  tasks: Task[];
  offset?: number;
  views?: View<TasksViewDefinition>[];
  spotlitViews?: View<TasksViewDefinition>[];
  vendor: Company;
  customer: Company;
  tasksToBeShown: TasksToBeShown;
  partnerCompanies?: Company[];
}
